<script>
  import Button from './common/Button.svelte'
  import Sharing from './common/Sharing.svelte'
</script>

<div class="card card--main dekstop">
  <div class="card__main">
    <div class="card__img">
      <img src={`./img/slides/lose.png`} alt="lose" />
    </div>
    <p>
      Упс, ты банкрот! Но не все истории про аутсорсинговые компании такие
      печальные.
    </p>
    <p>
      UCMS Group Russia уже 25 лет решает задачи клиентов и помогает им в самых
      разных ситуациях, включая те, что встретились тебе сегодня в игре. Мы
      входим в ТОП-3 крупнейших компаний в области расчёта заработной платы и
      кадрового делопроизводства и в ТОП-7 в рейтинге компаний в области
      аутсорсинга учётных функций.
    </p>
    <p>Ну что, попробуешь обогнать нас в рейтинге ещё раз?</p>
  </div>
  <Button onClick={() => document.location.reload()} text="Уже бегу" />
  <Button onClick={() => (document.location.href = 'https://www.ucmsgroup.ru')} isCenter text="Хочу знать секрет успеха UCMS" />
</div>
<Sharing />
